(function () {
  'use strict';
  var root = document.getElementById('vh-root');
  if (!root) return;
  var V = window.Moonhug || {};
  var cur = V.moneyCurrency || 'USD';
  var P;
  try { P = JSON.parse(root.querySelector('[data-vh-product]').textContent); } catch (e) { return; }
  var $ = function (s, r) { return (r || root).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
  var fmt = function (c) { try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur }).format(c / 100); } catch (e) { return '$' + (c / 100).toFixed(2); } };
  var ls = function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } };
  function hasMarketing() { try { var c = JSON.parse(ls('moonhug-consent') || 'null'); return !!(c && c.marketing === true); } catch (e) { return false; } }
  function withTtclid(url) {
    try {
      var o = JSON.parse(ls('moonhug-ttclid') || 'null');
      if (!o || !o.id || Date.now() - o.ts > 604800000 || !hasMarketing()) return url;
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'ttclid=' + encodeURIComponent(o.id);
    } catch (e) { return url; }
  }
  function postJSON(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  var byId = function (id) { return P.variants.filter(function (v) { return v.id === Number(id); })[0]; };

  var cards = $$('[data-vh-card]');
  var submit = $('[data-vh-submit]');
  var mainImg = $('[data-vh-main]') || document.querySelector('[data-gallery-main]');
  var thumbs = $$('[data-vh-thumb]');
  var busy = false;
  var active = cards.filter(function (c) { return c.getAttribute('aria-checked') === 'true'; })[0] || cards[0];
  var addon = $('[data-vh-addon]');
  var pbCheck = $('[data-vh-addon-check]');
  var pbQtyWrap = $('[data-vh-addon-qtywrap]');
  var pbQtySel = $('[data-vh-addon-qty]');
  var pbNote = $('[data-vh-addon-note]');
  var pbPriceEl = $('[data-vh-addon-price]');
  var pbTouched = false;

  function qty() { return active ? Number(active.getAttribute('data-vh-card')) : 1; }
  function chosen() { return active ? $$('[data-vh-pick]', active).map(function (s) { return byId(s.value); }) : []; }
  function pbOn() { return !!(P.pb && pbCheck && pbCheck.checked); }
  function pbQty() { return pbOn() ? Math.max(1, Number(pbQtySel && pbQtySel.value) || 1) : 0; }
  function syncAddon() {
    if (!P.pb || !pbCheck) return;
    var n = qty();
    if (pbQtySel) {
      var curQ = Number(pbQtySel.value) || n;
      var want = pbTouched ? Math.min(Math.max(curQ, 1), n) : n;
      pbQtySel.innerHTML = '';
      for (var i = 1; i <= n; i++) { var o = document.createElement('option'); o.value = String(i); o.textContent = String(i); if (i === want) o.selected = true; pbQtySel.appendChild(o); }
    }
    if (pbQtyWrap) pbQtyWrap.hidden = !(pbOn() && n > 1);
    if (pbPriceEl) pbPriceEl.textContent = '+ ' + fmt(P.pb.price * (pbOn() ? pbQty() : 1));
    if (addon) addon.classList.toggle('is-on', pbOn());
  }
  // Lines that go to the cart + the amount the checkout will show (bundle code, or 20% from $100 on everything)
  function totals() {
    var items = [];
    chosen().forEach(function (v) { if (!v) return; var ex = items.filter(function (it) { return it.id === v.id; })[0]; if (ex) ex.quantity += 1; else items.push({ id: v.id, quantity: 1, price: v.price }); });
    var q = pbQty();
    if (q > 0) items.push({ id: P.pb.id, quantity: q, price: P.pb.price, pb: true });
    var full = items.reduce(function (s, it) { return s + it.price * it.quantity; }, 0);
    var pbSum = q > 0 ? P.pb.price * q : 0;
    var th = !!(V.thresholdCode && full > 9999);
    var pct = P.thPct || 20;
    var pay = th
      ? items.reduce(function (s, it) { var line = it.price * it.quantity; return s + line - Math.round(line * pct / 100); }, 0)
      : (active ? Number(active.getAttribute('data-total')) : 0) + pbSum;
    return { items: items, pay: pay, th: th };
  }
  function showImage(src, alt, variantId) {
    if (mainImg && src) { if (mainImg.hasAttribute('srcset')) mainImg.removeAttribute('srcset'); mainImg.src = src; if (alt) mainImg.alt = alt; }
    thumbs.forEach(function (t) {
      var on = variantId ? t.getAttribute('data-variant') === String(variantId) : t.getAttribute('data-src') === src;
      t.setAttribute('aria-current', on ? 'true' : 'false');
    });
  }
  function showVariant(v) { if (v && v.image) showImage(v.image, P.title + ' – ' + v.label, v.id); }
  function syncThumb(s) { var img = s.parentNode.querySelector('[data-vh-pick-img]'); var v = byId(s.value); if (img && v && v.thumb) { img.src = v.thumb; img.alt = v.label; } }
  function refresh() {
    var list = chosen();
    var ok = list.length > 0 && list.every(function (v) { return v && v.available; });
    var t = totals();
    if (pbNote) pbNote.hidden = !(pbOn() && t.th);
    if (submit) { submit.disabled = busy || !ok; submit.textContent = !ok ? 'Sold out' : busy ? 'One moment…' : 'Buy now · ' + fmt(t.pay); }
  }
  function select(card, focus) {
    if (!card || card === active) return;
    var prev = active ? $$('[data-vh-pick]', active).map(function (s) { return s.value; }) : [];
    active = card;
    cards.forEach(function (c) {
      var on = c === card;
      c.setAttribute('aria-checked', on ? 'true' : 'false');
      c.tabIndex = on ? 0 : -1;
      var pk = $('[data-vh-picks]', c); if (pk) pk.hidden = !on;
    });
    $$('[data-vh-pick]', card).forEach(function (s, i) { if (prev[i] && byId(prev[i]) && byId(prev[i]).available) s.value = prev[i]; syncThumb(s); });
    if (focus) card.focus();
    syncAddon();
    refresh();
  }
  cards.forEach(function (c, idx) {
    c.addEventListener('click', function (e) { if (e.target.closest('[data-vh-picks]')) return; select(c); });
    c.addEventListener('keydown', function (e) {
      if (e.target.closest('select')) return;
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(c); }
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); select(cards[(idx + 1) % cards.length], true); }
      if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); select(cards[(idx - 1 + cards.length) % cards.length], true); }
    });
  });
  $$('[data-vh-pick]').forEach(function (s) { syncThumb(s); s.addEventListener('change', function () { syncThumb(s); showVariant(byId(s.value)); refresh(); }); });
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () { showImage(t.getAttribute('data-src'), t.getAttribute('data-alt'), t.getAttribute('data-variant')); });
  });
  if (pbCheck) pbCheck.addEventListener('change', function () { syncAddon(); refresh(); });
  if (pbQtySel) pbQtySel.addEventListener('change', function () { pbTouched = true; syncAddon(); refresh(); });
  syncAddon();

  if (submit) submit.addEventListener('click', function () {
    var list = chosen(), n = qty();
    if (busy || !list.length || !list.every(function (v) { return v && v.available; })) return;
    var err = $('[data-vh-error]'); if (err) err.hidden = true;
    var t = totals();
    var items = t.items.map(function (it) { return { id: it.id, quantity: it.quantity }; });
    busy = true; refresh();
    postJSON('/cart/add.js', { items: items })
      .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); })
      .then(function (cart) {
        var sum = (cart.items || []).reduce(function (s, it) { return s + (it.original_line_price != null ? it.original_line_price : it.original_price * it.quantity); }, 0);
        var code = null;
        if (V.thresholdCode && sum > 9999) code = V.thresholdCode;
        else if (P.codes && P.codes[String(n)]) code = P.codes[String(n)];
        if (code) return postJSON('/cart/update.js', { discount: code }).catch(function () {});
      })
     .then(function () { setTimeout(function () { window.location.href = withTtclid('/checkout'); }, 800); })
      .catch(function () { busy = false; refresh(); if (err) err.hidden = false; });
  });
  refresh();

  var buy = $('[data-vh-buy]');

  // Sticky buy bar on phones: visible between hero CTA and buy block / final CTA
  var bar = $('[data-vh-sticky]');
  var heroCta = $('[data-vh-hero-cta]');
  var fin = $('[data-vh-final]');
  if (bar && heroCta && buy && 'IntersectionObserver' in window) {
    var state = { hero: true, buy: false, fin: false };
    var consent = document.querySelector('[data-consent-banner]');
    var upd = function () {
      var blocked = consent && !consent.hidden;
      var show = !state.hero && !state.buy && !state.fin && !blocked && window.innerWidth < 768;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      var a = bar.querySelector('a'); if (a) a.tabIndex = show ? 0 : -1;
    };
    var watch = function (el, key) { new IntersectionObserver(function (es) { es.forEach(function (en) { state[key] = en.isIntersecting || en.boundingClientRect.top > window.innerHeight && key === 'hero'; }); upd(); }).observe(el); };
    watch(heroCta, 'hero'); watch(buy, 'buy'); if (fin) watch(fin, 'fin');
    if (consent && 'MutationObserver' in window) new MutationObserver(upd).observe(consent, { attributes: true, attributeFilter: ['hidden'] });
    window.addEventListener('resize', upd, { passive: true });
  }
})();